const state = {
    screenWindow: {
        visibleHeight: null,
        visibleScroll: null
    },

    inputHasFocus: false
};

export default state;



// WEBPACK FOOTER //
// ./src/store/Screen/state.js